
export const thirdYear = [
    
    {
        "url": require('../Assets/3rdYearImg/Abhay yadav.jpg'),
        "name": "Abhay Yadav",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Alok.jpeg'),
        "name": "Alok Das",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Anish_Kumar.jpg'),
        "name": "Anish Kumar",
        "instaLink": "https://www.instagram.com/anish24640?igsh=cXQ5enN2aXgwNTdm",
        "linkedinLink": "https://www.linkedin.com/in/anish-kumar-a6245a3b0?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    },
    {
        "url": require('../Assets/3rdYearImg/Amulya_Dadi2.jpg'),
        "name": "Amulya Dadi",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Asmit.jpg'),
        "name": "Asmit Kumar Shaw",
        "instaLink": "https://www.instagram.com/asmit.__18?igsh=MTN2c2tkNjF3cWI0ag==",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Atrayee_De.jpeg'),
        "name": "Atrayee De",
        "instaLink": "https://www.instagram.com/atrayeee_/?hl=en",
        "linkedinLink": "https://www.linkedin.com/in/atrayee-de",
    },
    {
        "url": require('../Assets/3rdYearImg/Siddhardha.jpg'),
        "name": " Banavath Sidhardha",
        "instaLink": "https://www.instagram.com/__sidhardha__83?igsh=MTdoMGJ3c253rnlpcg==",
        "linkedinLink": "https://www.linkedin.com/in/banavath-sidhardha-098557365?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    },
    {
        "url": require('../Assets/3rdYearImg/Dawlat_Kanungo.jpg'),
        "name": "Dawlat Kumar Kanungo",
        "instaLink": "https://www.instagram.com/dawla_tkanungo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/sai kiran2.jpg'),
        "name": "Janni Sai Kiran",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Bhaskar2.jpg'),
        "name": "K V V Bhaskar",
        "instaLink": "https://www.instagram.com/bhaskar_koralla?igsh=ZHBsbzUzc2pnYnZo",
        "linkedinLink": "https://www.linkedin.com/in/koralla-veera-venkata-bhaskar",
    },
    {
        "url": require('../Assets/3rdYearImg/Manoj.jpg'),
        "name": "Manoj Veturi",
        "instaLink": "https://www.instagram.com/manoj_veturi",
        "linkedinLink": "https://www.linkedin.com/in/manoj-veturi/",
    },
    {
        "url": require('../Assets/3rdYearImg/Karthik.jpg'),
        "name": "Paila Purna Durga Karthik",
        "instaLink": "https://www.instagram.com/blush4_karthik?igsh=MW9uamZoaWZmOGZkeQ==",
        "linkedinLink": "https://www.linkedin.com/in/purna-durga-karthik-paila-262321343?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/3rdYearImg/Pijush_Mandal.jpg'),
        "name": "Pijush Mandal",
        "instaLink": "https://www.instagram.com/pijushm_03?igsh=MTJnbDBlZHZqMmUybA==",
        "linkedinLink": "https://www.linkedin.com/in/pijush-mandal",
    },
    {
        "url": require('../Assets/3rdYearImg/Pradeepta.jpg'),
        "name": "Pradeepta Roy",
        "instaLink": "https://www.instagram.com/pradeepta__?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Prateek.jpg'),
        "name": "Prateek Pandey",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Pravat.jpeg'),
        "name": "Pravat Ranjan Naik",
        "instaLink": "https://www.instagram.com/_.pravat_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Praveen.jpg'),
        "name": "Praveen Kumar Vadlamuri",
        "instaLink": "https://www.instagram.com/praveen_7.0/",
        "linkedinLink": "https://www.linkedin.com/in/praveen-kumar-vadlamuri-893989333?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/3rdYearImg/pruthi.jpeg'),
        "name": "Pruthi Swarupa Nayak",
        "instaLink": "https://www.instagram.com/pruthi._?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Ravi.jpeg'),
        "name": "Ravi Shankar Mishra",
        "instaLink": "https://www.instagram.com/imravi_mishra16?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Rikhil.png'),
        "name": "Rikhil Kunta",
        "instaLink": "https://www.instagram.com/rikhil_06_08/?utm_source=ig_web_button_share_sheet",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Roshini2.jpeg'),
        "name": "Seepani Roshini",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Pryanksu.jpeg'),
        "name": "Pryanksu Chattopadhyay",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Rishul.jpg'),
        "name": "Rishul Shende",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Sabitendra_Saha2.jpg'),
        "name": "Sabitendra Saha",
        "instaLink": "https://www.instagram.com/saha_sabitendra?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Pani.jpg'),
        "name": "Sai Sree Prasad Pani",
        "instaLink": "https://www.instagram.com/pani62172/?__pwa=1#",
        "linkedinLink": "https://www.linkedin.com/in/sai-sree-prasad-pani-7746b1324/overlay/about-this-profile/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base%3BvuFGP%2BmiTFyvGIfGPNDe3Q%3D%3D",
    },
    {
        "url": require('../Assets/3rdYearImg/Samriddha3.jpg'),
        "name": "Samriddha Pal",
        "instaLink": "https://www.instagram.com/syntax_000?igsh=Mnlvd3BjY2o2eWI1",
        "linkedinLink": "https://www.linkedin.com/in/samriddha-pal-261b5b251?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/3rdYearImg/Saunak.jpg'),
        "name": "Saunak Kamilya",
        "instaLink": "https://www.instagram.com/____deadline_____dork?igsh=Y3VuMnd2Ym9leGRm",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Sayantika.jpg'),
        "name": "Sayantika Shome",
        "instaLink": "https://www.instagram.com/sayantika_.__?igsh=ZzdpdTUxMHFyNTZn",
        "linkedinLink": "https://www.linkedin.com/in/sayantika-shome-3a91ba335?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/3rdYearImg/Shibam.jpg'),
        "name": "Shibam Bhattacharjee",
        "instaLink": "https://www.instagram.com/shibam5543?igsh=c2J6bmN2aHp1MTV5",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/SHREYA DWIVEDI.jpg'),
        "name": "Shreya Dwivedi",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Soham.jpg'),
        "name": "Soham Banerjee",
        "instaLink": "https://www.instagram.com/soh4m.b_25?igsh=OHN4OW92Z3JhYm1y",
        "linkedinLink": "https://www.linkedin.com/in/soham-banerjee-10bba1334?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/3rdYearImg/Sourav.jpg'),
        "name": "Sourav Sen",
        "instaLink": "https://www.instagram.com/soura.v2445/?utm_source=ig_web_button_share_sheet",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Subham_Prasad.jpg'),
        "name": "Subham kumar Prasad",
        "instaLink": "https://www.instagram.com/_subham.prasad?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/swarnabha.jpeg'),
        "name": "Swarnabha Das",
        "instaLink": "https://www.instagram.com/sw3rn1.gg?igsh=MXJkZzZhemU4c2p2eQ==",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/3rdYearImg/Sukanya Paul.jpg'),
        "name": "Sukanya Paul",
        "instaLink": "https://www.instagram.com/_.chaotic_life._/?hl=en",
        "linkedinLink": "https://www.linkedin.com/in/sukanya-paul-445a91324/",
    },
    {
        "url": require('../Assets/3rdYearImg/Uday.jpg'),
        "name": "Uday Islam",
        "instaLink": "https://www.instagram.com/uday.islam_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        "linkedinLink": "",
    },


]
